import { apiSlice } from "../api/apiSlice";

export const projectApi = apiSlice.injectEndpoints({
    tagTypes: ["Projects"],
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: () => ({
                url: "/projects"
            }),
            providesTags: ["Projects"]
        }),
        getProject: builder.query({
            query: (id) => ({
                url: `/projects/${id}`
            }),
        }),
        addProject: builder.mutation({
            query: (data) => ({
                url: "/projects",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Projects"]
        }),
        editProject: builder.mutation({
            query: ({ id, data }) => ({
                url: `projects/${id}`,
                method: 'PATCH',
                body: data,
              }),
              async onQueryStarted({ id, data }, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                  apiSlice.util.updateQueryData('getProjects', undefined, (draft) => {
                      const draftProject = draft.find(
                          (c) => c.id == id
                          );
                        draftProject.state = data.state;
                  })
                );
               
                try {
                  await queryFulfilled;
                } catch {
                  patchResult.undo();
                }
              },
            invalidatesTags: ["Projects"]
        }),
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `/projects/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["Projects"]
        }),
    }),
});

export const { useGetProjectsQuery, useAddProjectMutation, useDeleteProjectMutation, useEditProjectMutation } = projectApi;
